module.exports = __webpack_public_path__ + "img/EBSoftware5.11eed6ef.png";